import React, { Fragment } from 'react';
import clsx from 'clsx';
import { createTheme, makeStyles, Button, Badge } from '@material-ui/core';
import red from '@material-ui/core/colors/red';
import { siteColors } from '../utils/domainValues';

const domainTheme = siteColors[`${window.location.hostname}`];
export const theme = createTheme({
  palette: domainTheme,
  overrides: {
    MuiMenuItem: {
      root: {
        fontSize: 15,
        minHeight: 42,
        fontFamily: 'Nunito Sans',
        fontWeight: 300,
      },
    },
    MuiTableRow: {
      root: {
        fontFamily: 'Nunito Sans',
        fontWeight: 300,
        minHeight: 45,
        height: 50,
        maxHeight: 55,
        '&$hover:hover': {
          backgroundColor: '#EFF4FB',
        },
      },
    },

    MuiInputLabel: {
      root: {
        fontFamily: 'Nunito Sans',
        fontWeight: 300,
      },
    },
    RaDatagrid: {
      expanded: { backgroundColor: '#EFF4FB' },
      headerCell: {
        fontWeight: 600,
        fontFamily: 'Nunito Sans',
      },
    },
    RaShow: {
      card: {
        color: 'black',
        fontWeight: 300,
        fontFamily: 'Nunito Sans',
      },
    },

    RaLabeled: {
      label: {
        color: 'black',
        fontWeight: 600,
        fontFamily: 'Nunito Sans',
        fontSize: 16,
      },
    },

    RaLayout: {
      content: {
        backgroundColor: '#FFFFFF',
        marginTop: -16,
        marginLeft: -8,
        zIndex: 0,
        padding: '24px !important',
        paddingLeft: '32px !important',
      },
    },

    RaAppBar: {
      toolbar: {
        paddingLeft: 8,
      },
    },

    RaBulkActionsToolbar: {
      toolbar: { zIndex: 0 },
    },
    MuiListItem: {
      button: {
        '&:hover': {
          backgroundColor: '#EFF4FB',
          color: '#1061A0',
        },
        '&:Mui-focused': {
          backgroundColor: '#FFFFFF',
        },
        '&.Mui-selected': {
          backgroundColor: '#EFF4FB',
          color: '#1061A0',
        },
      },
    },

    MuiTypography: {
      body1: {
        fontWeight: 300,
        fontFamily: 'Nunito Sans',
      },
      body2: {
        fontWeight: 300,
        fontFamily: 'Nunito Sans',
      },
    },

    MuiButton: {
      text: {
        fontFamily: 'Nunito Sans',
      },
      root: {
        minWidth: '20px',
        minHeight: '30px',
      },
    },
    MuiOutlinedInput: {
      input: {
        fontFamily: 'Nunito Sans',
        fontWeight: 300,
      },
    },
  },
});

const useSaveButtonStyles = makeStyles(({ spacing }) => ({
  button: {
    backgroundColor: theme.palette.primary.buttons,
    textTransform: 'capitalize',
    borderRadius: 2,
    textStyle: 'Nunito Sans',
  },
  leftIcon: {
    marginRight: spacing(2),
  },
  icon: {
    fontSize: 18,
  },
}));

export const SaveButton = ({ type, onClick, disabled, label, style }) => {
  const classes = useSaveButtonStyles();
  return (
    <Button
      disableElevation
      type={type}
      className={classes.button}
      variant='contained'
      color='primary'
      disabled={disabled}
      onClick={onClick || undefined}
      style={style}
      size='medium'
    >
      {`${label || 'Save'}`}
    </Button>
  );
};
const useCustomButtonStyles = makeStyles(({ spacing }) => ({
  button: {
    position: 'relative',
    backgroundColor: props => props.backgroundColor,
    color: props => props.color,
    '&:hover': {
      backgroundColor: props => props.backgroundColor,
      color: props => props.color,
    },
    textTransform: 'capitalize',
  },
  leftIcon: {
    marginRight: spacing(1),
  },
  icon: {
    fontSize: props => !props.fullSize && 18,
  },
  badge: {
    width: 20,
    minWidth: 20,
    height: 20,
    fontSize: 9,
    right: 10,
    backgroundColor: props => !props.notRed && '#E32939',
    color: '#FFFFFF',
    fontWeight: 300,
    zIndex: 0,
  },
}));

export const CustomButton = ({
  type,
  onClick,
  label,
  variant = 'contained',
  color,
  materialColor = 'primary',
  backgroundColor,
  Icon,
  size = 'medium',
  className,
  badgeContent,
  notRed,
  fullSize,
  ...rest
}) => {
  const classes = useCustomButtonStyles({
    backgroundColor,
    color,
    notRed,
    fullSize,
  });
  return (
    <Button
      type={type}
      className={clsx(classes.button, className)}
      variant={variant}
      color={materialColor}
      size={size}
      onClick={onClick || undefined}
      {...rest}
    >
      {Icon && (
        <Fragment>
          {badgeContent ? (
            <Badge
              color='secondary'
              badgeContent={badgeContent}
              classes={{ badge: classes.badge }}
            >
              <Icon className={clsx(classes.leftIcon, classes.icon)} />
            </Badge>
          ) : (
            <Icon className={clsx(classes.leftIcon, classes.icon)} />
          )}
        </Fragment>
      )}
      {label}
    </Button>
  );
};
